module.exports = __webpack_public_path__ + "img/bodegasIcon.3ec104b4.jpg";